


<div class="side-menu" *ngIf="isLoggedIn">
  <app-sp-sidenav [isSidebarCollapsed]="isSidebarCollapsed"
                  (sidebarToggle)="onSidebarToggle()">
  </app-sp-sidenav>

  <!-- <qds-button class="sidebar-toggle-btn" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }"
              (click)="onSidebarToggle()" size="large" importance="subdued"
              icon-name='chevron-right-edge'>
  </qds-button> -->

</div>

<div class="qds-main-section expandable gap8" [class.expanded]="isExpanded" [ngClass]="{'content-expanded': isSidebarCollapsed }">

  <app-header *ngIf="isLoggedIn" style="width:100%"></app-header>
  <div class="root">
    <router-outlet></router-outlet>
  </div>

  <!--<app-footer></app-footer>-->

</div>

